import * as React from "react";
import { Card } from "antd";

interface Props {}
export const OblivusNoUnmanagedNodePool: React.FC<Props> = ({}) => {
  return (
    <div className="cpln-form-section cpln-ant-tab-content">
      <Card>
        <div className="text-lg font-semibold">No Unmanaged Node Pools</div>
      </Card>
    </div>
  );
};
